import React, { useState, useEffect } from 'react';
import '../styles/Pages.css';

export default function Despesas() {
  const [despesas, setDespesas] = useState([]);
  const [cartoes, setCartoes] = useState([]);
  const [contas, setContas] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    descricao: '',
    fornecedor: '',
    valor: '',
    categoria: 'alimentacao',
    tipo: 'variavel',
    recorrencia: 'unica',
    data: new Date().toISOString().split('T')[0],
    forma_pagamento: 'debito',
    bankAccountId: '',
    creditCardId: '',
    parcelado: false,
    num_parcelas: 1
  });

  useEffect(() => {
    carregarDespesas();
    carregarCartoes();
    carregarContas();
  }, []);

  const carregarDespesas = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/despesas', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setDespesas(data.despesas || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const carregarCartoes = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/bank/cartoes', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setCartoes(data.cartoes || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const carregarContas = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/bank/contas', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setContas(data.contas || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const handleAddOuEditar = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const url = editingId ? `/api/despesas/${editingId}` : '/api/despesas';
    const method = editingId ? 'PUT' : 'POST';

    const dados = {
      ...formData,
      valor: parseFloat(formData.valor),
      num_parcelas: parseInt(formData.num_parcelas),
      bankAccountId: formData.bankAccountId ? parseInt(formData.bankAccountId) : null,
      creditCardId: formData.creditCardId ? parseInt(formData.creditCardId) : null,
      parcelado: formData.parcelado && formData.num_parcelas > 1
    };

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(dados)
      });
      const data = await res.json();
      if (data.success) {
        handleCancelar();
        carregarDespesas();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleEditar = (despesa) => {
    setFormData({
      descricao: despesa.descricao,
      fornecedor: despesa.fornecedor,
      valor: despesa.valor,
      categoria: despesa.categoria,
      tipo: despesa.tipo,
      recorrencia: despesa.recorrencia || 'unica',
      data: despesa.data.split('T')[0],
      forma_pagamento: despesa.forma_pagamento || (despesa.creditCardId ? 'credito' : 'debito'),
      bankAccountId: despesa.bankAccountId || '',
      creditCardId: despesa.creditCardId || '',
      parcelado: despesa.parcelado || false,
      num_parcelas: despesa.num_parcelas || 1
    });
    setEditingId(despesa.id);
    setShowForm(true);
  };

  const handleDeletar = async (id) => {
    if (!window.confirm('Deletar despesa?')) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/despesas/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) carregarDespesas();
    } catch (error) { console.error('Erro:', error); }
  };

  const handleCancelar = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({ descricao: '', fornecedor: '', valor: '', categoria: 'alimentacao', tipo: 'variavel', recorrencia: 'unica', data: new Date().toISOString().split('T')[0], forma_pagamento: 'debito', bankAccountId: '', creditCardId: '', parcelado: false, num_parcelas: 1 });
  };

  const handleFormaPagamento = (forma) => {
    setFormData({
      ...formData,
      forma_pagamento: forma,
      bankAccountId: forma === 'credito' ? '' : formData.bankAccountId,
      creditCardId: forma === 'debito' ? '' : formData.creditCardId,
      parcelado: forma === 'debito' ? false : formData.parcelado
    });
  };

  const ehCredito = formData.forma_pagamento === 'credito';

  return (
    <div className="page">
      <h1>💸 Despesas</h1>
      <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
        {showForm ? '✕ Cancelar' : '+ Adicionar Despesa'}
      </button>

      {showForm && (
        <form onSubmit={handleAddOuEditar} className="form-card">
          <div className="form-group">
            <label>Descrição</label>
            <input type="text" value={formData.descricao} onChange={(e) => setFormData({...formData, descricao: e.target.value})} placeholder="Ex: Compras no mercado" required />
          </div>

          <div className="form-group">
            <label>Fornecedor</label>
            <input type="text" value={formData.fornecedor} onChange={(e) => setFormData({...formData, fornecedor: e.target.value})} placeholder="Ex: Supermercado X" required />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Valor (R$)</label>
              <input type="number" value={formData.valor} onChange={(e) => setFormData({...formData, valor: e.target.value})} step="0.01" required />
            </div>
            <div className="form-group">
              <label>Data</label>
              <input type="date" value={formData.data} onChange={(e) => setFormData({...formData, data: e.target.value})} required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Categoria</label>
              <select value={formData.categoria} onChange={(e) => setFormData({...formData, categoria: e.target.value})}>
                <option value="alimentacao">Alimentação</option>
                <option value="transporte">Transporte</option>
                <option value="moradia">Moradia</option>
                <option value="saude">Saúde</option>
                <option value="educacao">Educação</option>
                <option value="lazer">Lazer</option>
                <option value="investimento">Investimento</option>
                <option value="outro">Outro</option>
              </select>
            </div>
            <div className="form-group">
              <label>Tipo</label>
              <select value={formData.tipo} onChange={(e) => setFormData({...formData, tipo: e.target.value})}>
                <option value="variavel">Variável</option>
                <option value="fixa">Fixa</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Recorrência</label>
              <select value={formData.recorrencia} onChange={(e) => setFormData({...formData, recorrencia: e.target.value})}>
                <option value="unica">Única</option>
                <option value="recorrente">Recorrente (mensal)</option>
              </select>
            </div>
            <div className="form-group">
              <label>Forma de Pagamento</label>
              <select value={formData.forma_pagamento} onChange={(e) => handleFormaPagamento(e.target.value)}>
                <option value="debito">Débito</option>
                <option value="credito">Crédito</option>
              </select>
            </div>
          </div>

          {ehCredito ? (
            <div className="form-group">
              <label>Cartão de Crédito</label>
              <select value={formData.creditCardId} onChange={(e) => setFormData({...formData, creditCardId: e.target.value})} required>
                <option value="">Selecionar cartão</option>
                {cartoes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
          ) : (
            <div className="form-group">
              <label>Conta (Débito)</label>
              <select value={formData.bankAccountId} onChange={(e) => setFormData({...formData, bankAccountId: e.target.value})} required>
                <option value="">Selecionar conta</option>
                {contas.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
          )}

          {ehCredito && (
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.parcelado}
                  onChange={(e) => setFormData({...formData, parcelado: e.target.checked})}
                />
                Parcelar em múltiplas parcelas
              </label>
            </div>
          )}

          {formData.parcelado && (
            <div className="form-group">
              <label>Número de Parcelas (até 24)</label>
              <input
                type="number"
                min="2"
                max="24"
                value={formData.num_parcelas}
                onChange={(e) => setFormData({...formData, num_parcelas: e.target.value})}
              />
              {formData.num_parcelas > 1 && formData.valor && (
                <p className="info-parcela">
                  Valor por parcela: R$ {(parseFloat(formData.valor) / parseInt(formData.num_parcelas)).toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                </p>
              )}
            </div>
          )}

          <div className="form-buttons">
            <button type="submit" className="btn-primary">{editingId ? 'Atualizar' : 'Adicionar'}</button>
            <button type="button" className="btn-secondary" onClick={handleCancelar}>Cancelar</button>
          </div>
        </form>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Fornecedor</th>
              <th>Categoria</th>
              <th>Valor</th>
              <th>Data</th>
              <th>Pagamento</th>
              <th>Tipo</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {despesas.map(d => (
              <tr key={d.id}>
                <td>{d.descricao}</td>
                <td>{d.fornecedor}</td>
                <td><span className="category">{d.categoria}</span></td>
                <td>R$ {parseFloat(d.valor).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</td>
                <td>{new Date(d.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</td>
                <td>
                  <span className={`pagamento-badge ${d.forma_pagamento || 'debito'}`}>
                    {d.forma_pagamento === 'credito' ? '💳 Crédito' : '🏦 Débito'}
                  </span>
                  <div className="pagamento-origem">{d.CreditCard?.nome || d.BankAccount?.nome || ''}</div>
                </td>
                <td><span className="type-badge">{d.parcelado ? `${d.parcela_atual}/${d.num_parcelas}` : d.recorrencia}</span></td>
                <td>
                  <button type="button" className="btn-small" onClick={() => handleEditar(d)}>✏️ Editar</button>
                  <button type="button" className="btn-small danger" onClick={() => handleDeletar(d.id)}>🗑️ Deletar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
